var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinRB3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4814_149149)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83594 5.22083V2.74167H8.33594C8.61094 2.74167 8.83594 2.51854 8.83594 2.24583C8.83594 1.97312 8.61094 1.75 8.33594 1.75H3.33594C3.06094 1.75 2.83594 1.97312 2.83594 2.24583C2.83594 2.51854 3.06094 2.74167 3.33594 2.74167H3.83594V5.22083C3.83594 6.04392 3.16594 6.70833 2.33594 6.70833V7.7H5.32094V11.1708L5.82094 11.6667L6.32094 11.1708V7.7H9.33594V6.70833C8.50594 6.70833 7.83594 6.04392 7.83594 5.22083Z",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2325 11.8706V12.8333H7.47046V12.0187L9.20337 10.1969C9.35642 10.0216 9.47984 9.86488 9.57365 9.72664C9.66745 9.58594 9.73534 9.45881 9.7773 9.34526C9.82174 9.2317 9.84395 9.12926 9.84395 9.03792C9.84395 8.88241 9.8205 8.75281 9.7736 8.64913C9.72917 8.54298 9.66252 8.46275 9.57365 8.40845C9.48725 8.35414 9.37987 8.32699 9.25151 8.32699C9.12314 8.32699 9.01082 8.36401 8.91455 8.43807C8.81828 8.51213 8.74299 8.61334 8.68868 8.7417C8.63684 8.87006 8.61092 9.01447 8.61092 9.17493H7.35938C7.35938 8.84414 7.4396 8.54175 7.60006 8.26774C7.76298 7.99373 7.98885 7.77527 8.27767 7.61235C8.56649 7.44695 8.90097 7.36426 9.28113 7.36426C9.67856 7.36426 10.0118 7.42597 10.2809 7.5494C10.55 7.67282 10.7524 7.85179 10.8881 8.0863C11.0264 8.31835 11.0955 8.59852 11.0955 8.92684C11.0955 9.11445 11.0659 9.29465 11.0066 9.46745C10.9474 9.64025 10.8622 9.81181 10.7511 9.98214C10.6401 10.15 10.5043 10.3228 10.3438 10.5005C10.1858 10.6783 10.0056 10.8671 9.80322 11.0671L9.1071 11.8706H11.2325Z",
    fill: "#777777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4814_149149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinRB3);
export default __webpack_public_path__ + "static/media/pin_r_b3.6114ff898f1b42b833b4a78ba7785735.svg";
export { ForwardRef as ReactComponent };